import type {
  InvestorContactCreateData,
  InvestorContactSearchResult,
} from '@/types/investor';
import { EMPTY_CONTACT_FORM_DATA } from './investorContactFormValidation';

export function contactFullName(contact: InvestorContactSearchResult): string {
  return `${contact.first_name} ${contact.last_name}`;
}

/**
 * Turns an existing contact into contact form data for another investor.
 *
 * Only the person travels: their details, role and notification preferences.
 * Primary flag, signatory rights and portal access are authority over one
 * specific investor, so they start from the blank defaults and have to be
 * granted deliberately on the new one.
 */
export function contactFormDataFromExisting(
  contact: InvestorContactSearchResult
): InvestorContactCreateData {
  return {
    ...EMPTY_CONTACT_FORM_DATA,
    first_name: contact.first_name,
    last_name: contact.last_name,
    email: contact.email ?? '',
    phone: contact.phone ?? '',
    mobile: contact.mobile ?? '',
    role: contact.role,
    title: contact.title ?? '',
    department: contact.department ?? '',
    receives_reports: contact.receives_reports,
    receives_capital_calls: contact.receives_capital_calls,
    receives_distributions: contact.receives_distributions,
    address_line_1: contact.address_line_1 ?? '',
    address_line_2: contact.address_line_2 ?? '',
    city: contact.city ?? '',
    postcode: contact.postcode ?? '',
    country: contact.country ?? '',
  };
}

// An investor rejects two contacts with the same email, so callers check
// before the form opens rather than failing on save.
export function isEmailTaken(
  contacts: readonly { email?: string | null }[],
  email?: string | null
): boolean {
  if (!email) return false;
  const target = email.toLowerCase();
  return contacts.some((contact) => contact.email?.toLowerCase() === target);
}
